module.exports = __webpack_public_path__ + "static/Award3-266ce0b02fe48931c9d72413bb63a733.png";